import { mapValues as _mapValues } from 'lodash';

import { Inputs, Input, Method } from './interfaces';
import resultValue from './result_value';

export default function (inputs: Inputs = {}, method: Method = Method.PLUS): Record<string, number> {
    return _mapValues(inputs, (input: Input) => resultValue(input, method));
}
